import _ from 'lodash';
// 小数点保留 decimal位
export function precision(n, decimals = 2) {
    const N = 10 ** decimals;
    return Math.round(n * N) / N;
}
export function accMul(arg1, arg2) {
    let m = 0;
    const s1 = arg1.toString();
    const s2 = arg2.toString();
    try {
        m += s1.split('.')[1].length;
    }
    catch (e) { }
    try {
        m += s2.split('.')[1].length;
    }
    catch (e) { }
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}
/**
 * 带容错
 */
export function toLocaleNumber(n) {
    if (_.isNumber(n)) {
        return n.toLocaleString();
    }
    else {
        return '-';
    }
}
/**
 * 用于 input change
 * 整数精度 自动调整  step
 * */
export function toStepStrictly(value, step) {
    if (value === '') {
        return false;
    }
    const _value = parseInt(value);
    /** isNumber 判断  NaN 也会认为是数字 */
    if (!_.isNumber(value)) {
        return false;
    }
    if (_value <= step) {
        return step;
    }
    const ceil = Math.ceil(_value / step);
    return ceil * step;
}
// 千分位
export function toThousands(value) {
    return _.toNumber(value).toLocaleString();
}
const ARABIC_NUMBER_DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
const CHINESE_NUMBER_ZERO = '零';
const CHINESE_NUMBER_SMALL_UNITS = ['', '十', '百', '千'];
const CHINESE_NUMBER_LARGE_UNITS = ['', '万', '亿', '万亿'];
function integerSectionToChineseUnits(value) {
    let result = '';
    let shouldAppendZero = false;
    const divisors = [1000, 100, 10, 1];
    divisors.forEach((divisor, index) => {
        const digit = Math.floor(value / divisor) % 10;
        if (digit === 0) {
            if (result && value % divisor !== 0)
                shouldAppendZero = true;
            return;
        }
        if (shouldAppendZero)
            result += CHINESE_NUMBER_ZERO;
        result += ARABIC_NUMBER_DIGITS[digit];
        result += CHINESE_NUMBER_SMALL_UNITS[divisors.length - index - 1];
        shouldAppendZero = false;
    });
    return result;
}
/**
 * 将安全整数转换为“阿拉伯数字 + 中文单位”，用于积分数量等非货币场景。
 */
export function integerToChineseUnits(value) {
    if (!Number.isSafeInteger(value))
        return '';
    if (value === 0)
        return ARABIC_NUMBER_DIGITS[0];
    const sign = value < 0 ? '-' : '';
    const sections = [];
    let remaining = Math.abs(value);
    while (remaining > 0) {
        sections.unshift(remaining % 10000);
        remaining = Math.floor(remaining / 10000);
    }
    let result = '';
    let hasEmptySection = false;
    sections.forEach((section, index) => {
        if (section === 0) {
            if (result)
                hasEmptySection = true;
            return;
        }
        if (result && (hasEmptySection || section < 1000)) {
            result += CHINESE_NUMBER_ZERO;
        }
        result += integerSectionToChineseUnits(section);
        result += CHINESE_NUMBER_LARGE_UNITS[sections.length - index - 1] || '';
        hasEmptySection = false;
    });
    return `${sign}${result}`;
}
export const getLineBarProportion = (mol, den) => {
    return ((mol / den) * 100).toFixed(2);
};
